<template>
    <Modal class="tiw__step__addToCartWithoutSms">
        <template #header>
            <p class="tiw__step__addToCartWithoutSms__header tiw__h2">
                <AwardIcon />
                {{ useTranslate("tiw__addToCart__title") }}
            </p>
            <p>{{ useTranslate("tiw__addToCartWithoutSms") }}</p>
        </template>
        <div class="tiw__step__addToCartWithoutSms__body">
            <template v-if="!isSigned">
                <div class="tiw__step__addToCartWithoutSms__warn">
                    {{ useTranslate("tiw__addToCart__warn") }}
                </div>
            </template>
            <div class="tiw__step__addToCartWithoutSms__actions">
                <Button
                    type="button"
                    :disabled="loadingToNext"
                    :loading="loadingToNext"
                    @click="onAddToCart"
                >
                    <span>
                        {{ useTranslate("tiw__addToCart__addToCart") }}
                    </span>
                </Button>
            </div>
        </div>
    </Modal>
</template>

<script lang="ts">
export default {
    name: "AddToCartWithoutSms",
};
</script>

<script setup lang="ts">
/**
 * * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [AddToCart]
 * Модальное окно / экран "Ура! Все готово! Добавить в корзину"
 */

// Store
import { ref } from "vue";

// Components
import Modal from "@/components/modal/modal.vue";
// import Checkbox from "@/ui/checkbox/checkbox.vue";
import { BugTrackerSection, useBugTracker } from "@/helpers/bugTracker";
import parseStringPrice from "@/helpers/parseStringPrice";
import { useAnalyticsEventAddToCart } from "@/hooks/useAnalytics/useAnalytics";
// Hooks
import useStoreResetter from "@/hooks/useStoreResetter/useStoreResetter";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useChooseDeviceStore } from "@/stores/chooseDevice/chooseDevice";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice";
import { useSuccessfulEvaluationStore } from "@/stores/successfulEvaluation/successfulEvaluation";
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";
// Icons
import AwardIcon from "@/ui/icons/award.vue";

const TIWStore = useTIWStore();
const ChooseDeviceStore = useChooseDeviceStore();
const HowYouRateDeviceStore = useHowYouRateDeviceStore();
const SuccessfulEvaluationStore = useSuccessfulEvaluationStore();

const isSigned = ref<boolean>(true);
const loadingToNext = ref<boolean>(false);

const onAddToCart = async () => {
    loadingToNext.value = true;

    try {
        useAnalyticsEventAddToCart();

        isSigned.value = true;

        const onCartData = {
            brand: ChooseDeviceStore.brandName,
            device_id: HowYouRateDeviceStore.registeringDeviceData.deviceId,
            device_imei: ChooseDeviceStore.field_imei.value,
            trade_up_model: TIWStore.INJECTED_GOOD?.panelTitle ?? null,
            trade_up_price: TIWStore.INJECTED_GOOD
                ? String(parseStringPrice(TIWStore.INJECTED_GOOD.panelPrice))
                : null,
            model: ChooseDeviceStore.deviceChain.join(" "),
            modelData: {
                brand: ChooseDeviceStore.field_brand.value?.name || "",
                category: ChooseDeviceStore.field_category.value?.name || "",
                model: ChooseDeviceStore.field_model.value?.name || "",
                other: ChooseDeviceStore.field_storage.value?.storage || "",
                color: ChooseDeviceStore.field_color.value?.color || "",
                code: ChooseDeviceStore.code || "",
            },
            price: String(parseStringPrice(HowYouRateDeviceStore.calculatedDeviceData.panelCost)),
            trade_in_price: String(
                parseStringPrice(
                    typeof HowYouRateDeviceStore.calculatedDeviceData.panelTradeInSale === "string"
                        ? HowYouRateDeviceStore.calculatedDeviceData.panelTradeInSale
                        : HowYouRateDeviceStore.calculatedDeviceData.panelTradeInSale.tradeInSale,
                ),
            ),
            top_up_price: HowYouRateDeviceStore.calculatedDeviceData.panelActionSale
                ? String(
                      parseStringPrice(
                          HowYouRateDeviceStore.calculatedDeviceData.panelActionSale.actionSale,
                      ),
                  )
                : null,
            grade: HowYouRateDeviceStore.registeringDeviceData.grade,
            final_price: true,
            first_name: SuccessfulEvaluationStore.destructuredFio.firstName,
            last_name: SuccessfulEvaluationStore.destructuredFio.lastName,
            email: SuccessfulEvaluationStore.fields.email,
            phone: SuccessfulEvaluationStore.fields.phone,
            signingType: HowYouRateDeviceStore.chosenSigningType,
        };

        TIWStore.INJECTED_TIW.current_api.onCart(onCartData);
        TIWStore.closeWidget();
        useStoreResetter();
    } catch (e) {
        useBugTracker("AddToCart - it4CheckContractSign", BugTrackerSection.ERROR, {
            exception: e.message,
            request: {
                token: TIWStore.WIDGET_DATA.token,
                deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
            },
        });
    }

    loadingToNext.value = false;
};
</script>

<style lang="scss" src="./addToCartWithoutSms.scss"></style>
